import {
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    className as _$cn,
} from 'intact';
import {Portal} from '../portal';
import {Icon} from '../icon';
import {Transition} from 'intact';
import {stopPropagation} from '../utils';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        onMaskClick,
        onCloseClick,
        onPrevClick,
        onNextClick,
        onAfterLeave,
        isImage,
        isVideo,
        isAudio,
        getTitle,
        getCounterText,
        shouldShowNavigation,
        getAudioCardAssetSrc,
    } = this.viewer;
    
    const {item, hasPrev, hasNext, container, value} = this.get();
    const {k} = this.config;
    const currentItem = item || {
        name: '',
        src: '',
        poster: '',
    };
    
    return _$cc(Portal, {
        'container': container,
        'children': (
            _$cc(Transition, {
                'show': value,
                'appear': value,
                'name': 'k-fade',
                'onAfterLeave': onAfterLeave,
                'children': (
                    (value) ?
                        _$ce(2, 'div', [
                            _$ce(2, 'div', [
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', getTitle(), 0, _$cn(`${k}-media-viewer-title`), {
                                        'title': getTitle()
                                    }),
                                    (getCounterText()) ?
                                        _$ce(2, 'div', getCounterText(), 0, _$cn(`${k}-media-viewer-counter`)) :
                                        undefined
                                ], 0, _$cn(`${k}-media-viewer-heading`)),
                                _$ce(2, 'button', (
                                    _$cc(Icon, {
                                        'className': _$cn(`${k}-icon-close-bold`)
                                    })
                                ), 2, _$cn(`${k}-media-viewer-close`), {
                                    'type': 'button',
                                    'title': '关闭预览',
                                    'aria-label': '关闭预览',
                                    'ev-click': onCloseClick
                                })
                            ], 4, _$cn(`${k}-media-viewer-header`), {
                                'ev-click': stopPropagation
                            }),
                            (shouldShowNavigation()) ?
                                _$ce(2, 'button', (
                                    _$cc(Icon, {
                                        'className': _$cn(`${k}-icon-left`)
                                    })
                                ), 2, _$cn(`${k}-media-viewer-prev`), {
                                    'type': 'button',
                                    'title': '上一个',
                                    'aria-label': '上一个',
                                    'disabled': !hasPrev,
                                    'ev-click': onPrevClick
                                }) :
                                undefined,
                            (shouldShowNavigation()) ?
                                _$ce(2, 'button', (
                                    _$cc(Icon, {
                                        'className': _$cn(`${k}-icon-right`)
                                    })
                                ), 2, _$cn(`${k}-media-viewer-next`), {
                                    'type': 'button',
                                    'title': '下一个',
                                    'aria-label': '下一个',
                                    'disabled': !hasNext,
                                    'ev-click': onNextClick
                                }) :
                                undefined,
                            _$ce(2, 'div', (
                                (isImage()) ?
                                    _$ce(2, 'img', null, 1, _$cn(`${k}-media-viewer-image`), {
                                        'src': currentItem.src,
                                        'alt': currentItem.name,
                                        'draggable': false,
                                        'ev-click': stopPropagation
                                    }) :
                                    isVideo() ?
                                        _$ce(2, 'video', null, 1, _$cn(`${k}-media-viewer-video`), {
                                            'src': currentItem.src,
                                            'poster': currentItem.poster || undefined,
                                            'controls': true,
                                            'autoplay': true,
                                            'preload': 'metadata',
                                            'playsinline': true,
                                            'ev-click': stopPropagation
                                        }) :
                                        isAudio() ?
                                            _$ce(2, 'div', [
                                                _$ce(2, 'div', (
                                                    _$ce(2, 'img', null, 1, _$cn(`${k}-media-viewer-audio-cover-image`), {
                                                        'src': getAudioCardAssetSrc(),
                                                        'alt': '',
                                                        'draggable': false
                                                    })
                                                ), 2, _$cn(`${k}-media-viewer-audio-cover`)),
                                                _$ce(2, 'div', currentItem.name, 0, _$cn(`${k}-media-viewer-audio-title`)),
                                                _$ce(2, 'audio', null, 1, _$cn(`${k}-media-viewer-audio-player`), {
                                                    'src': currentItem.src,
                                                    'controls': true,
                                                    'autoplay': true,
                                                    'preload': 'metadata'
                                                })
                                            ], 4, _$cn(`${k}-media-viewer-audio`), {
                                                'ev-click': stopPropagation
                                            }) :
                                            undefined
                            ), 0, _$cn(`${k}-media-viewer-stage`))
                        ], 0, _$cn({
                            [`${k}-media-viewer`]: true,
                            [this.get('className')]: this.get('className'),
                        }), {
                            'ev-click': onMaskClick
                        }) :
                        undefined
                )
            })
        )
    });
};